import { atom } from 'jotai';
import { pageStateVM, editStateVM, modelVM } from './payor_edit_view_models';
import { AdminPayorModel, EditState, PayorEditPageState } from './payor_edit_types';

export const pageStateAtom = atom<PayorEditPageState>(pageStateVM());
export const editStateAtom = atom<EditState>(editStateVM());
export const editModelAtom = atom<AdminPayorModel>(modelVM());
